//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';

import { getSyndicatedContentStatus } from '@apis/rights-management/rightsManagementApi';
import { SyndicatedContentStatusResponse } from '@apis/rights-management/rightsManagementApiModels';
import ClientId from '@models/ClientId';
import Cuid from '@models/Cuid';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';

export const useSyndicatedStatusQuery = (
  cuid: Cuid,
  creatorClientId: ClientId,
  enabled?: boolean,
) =>
  useQuery<SyndicatedContentStatusResponse>({
    enabled,
    queryKey: [
      QueryKeyConstants.UniversalImageActions,
      QueryKeyConstants.UniversalImageActionsRightsSyndicatedStatus,
      creatorClientId,
      cuid,
    ],
    queryFn: async ({ signal }) =>
      getSyndicatedContentStatus({ cuid, creatorClientId }, { signal }),
    staleTime: FIVE_MINUTES_STALE_TIME,
  });
